module.exports = __webpack_public_path__ + "static/media/img-placeholder.8865f01b.jpg";